// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".button-min-width[data-v-d0a89fda]{min-width:16rem}.ufs-button-height[data-v-d0a89fda]{height:60px}.fade-enter-active[data-v-d0a89fda],.fade-leave-active[data-v-d0a89fda]{transition:opacity .5s}.fade-enter[data-v-d0a89fda],.fade-leave-to[data-v-d0a89fda]{opacity:0}.button-small.ufs-button-height[data-v-d0a89fda]{height:40px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
